export default {
  views: {
    subGroups: {
      assign: "Asignar subgrupos",
      tagManager: "Gestor de etiquetas: elige tu grupo",
      successAssign: "¡Asombroso! Has actualizado los subgrupos de tu grupo.",

      errors: {
        assign: "¡UH oh! No se puede asignar un subgrupo"
      },

      table: {
        firstName: "Nombre de pila",
        lastName: "Apellido",
        username: "Nombre de usuario",
        subGroup: "Subgrupo"
      }
    },

    classes: {
      label: "Grupo",
      editGroup: "Editar grupo - Paso",
      addGroup: "Agregar grupo - Paso",
      classesCount: "{count} grupos",

      errors: {
        group: "No se pudieron cargar los datos del grupo.",
        update: "No se pudo actualizar el grupo. Vuelve a intentarlo más tarde",
        create: "No se pudo crear un grupo",
        emptyList: "Todavía no tienes ningún grupo en la escuela seleccionada."
      },

      messages: {
        create: "¡Se ha creado un grupo con éxito!"
      }
    },

    schools: {
      label: "Escuela",

      errors: {
        emptyList: "No tienes ninguna escuela disponible.",
        fetchError: "Error al buscar escuelas"
      }
    },

    teachers: {
      teachersCount: "{count} profesores",

      errors: {
        emptyList: "Aún no tienes maestros.",
        details: " No se pudieron obtener los datos del profesor."
      },

      titles: {
        edit: "Profesor de edición"
      },

      messages: {
        create: "¡Un profesor ha sido creado con éxito!",
        update: "¡Un profesor ha sido actualizado!"
      }
    },

    grammarToGo: {
      title: "Gramática para llevar"
    },

    home: {
      wantToAssign: "Quiero asignar una lección",
      whatStudentsDo: "¿Qué están haciendo sus estudiantes en Little Bridge?",
      howManyCountries: "¿En cuántos países tienen sus estudiantes DigiPals?",
      numActivities: "¿Cuántas actividades han realizado tus alumnos?",
      numFriends: "¿Cuántos DigiPals tienen sus estudiantes?",
      numMessages: "¿Cuántos mensajes han enviado sus alumnos?",

      errors: {
        dashboard: "No se pudieron recuperar los datos del panel."
      }
    },

    knowledgeBase: {
      title: "Base de conocimientos",

      errors: {
        fetch: "No se pudo recuperar la base de conocimientos",
        details: "No se pudo obtener el detalle de la base de conocimientos"
      }
    },

    lessons: {
      label: "Lesson",

      subgroups: "Subgrupos",

      messages: {
        setLessonsAuto:
          "Little Bridge ahora establecerá lecciones para sus estudiantes automáticamente. Avanzarán a través de las lecciones a su propio ritmo. Puede anular esto en cualquier momento asignando una lección a sus alumnos."
      },

      hasBeenAssigned: "Esta lección ha sido asignada.",
      assignAnother: "Asignar otra lección",
      assignMyself: "Quiero asignar lecciones yo mismo",
      assignAuto: "Quiero que Little Bridge asigne lecciones automáticamente",
      lessonId: "Lección {LessonId}",
      set: "Establecer lección",
      activity: "Actividad",
      resources: "Recursos",

      statuses: {
        selected: "Lección seleccionada",
        archived: "Archivado",
        current: "Lección actual",
        unassigned: "No asignado"
      },

      stepper: {
        titles: {
          step1: "Paso 1 - ¿A quién le quieres asignar una lección?",
          step2: "Paso 2: elige una lección",
          step3: "Paso 3 - Confirmar"
        }
      },

      errors: {
        fetch: "No se pudieron recuperar las lecciones."
      }
    },

    reports: {
      title: "Generador de informes",
      type: "Tipo de informe",
      generate: "Generar informe",

      level: "Informe de nivel",
      lesson: "Informe de la lección",

      test: "Informe de Checkpoint",
      diagnostic: "Informe de diagnóstico",
      baseline: "Informe de referencia",
      progress: "Evaluación del progreso",
      students: "estudiantes",

      download: {
        pdf: "Descargar como PDF",
        csv: "Descargar como CSV",
        lessonPlan: "Descargar el plan de lecciones en PDF"
      },

      errors: {
        generate:
          "No se pudo generar un informe. Por favor, inténtelo de nuevo más tarde."
      }
    },

    students: {
      label: "Estudiantes",
      editStudent: "Editar alumno",
      stundentsCount: "{count} estudiantes",
      add: "Agregar alumno",
      saveAndDownload: "Guardar y descargar la lista de estudiantes",
      download: "Descargar lista de estudiantes",

      import: {
        step: "Importar alumnos: paso ",
        clickVideo: "Haga clic aquí para ver un breve video tutorial",
        copyPasteFirst:
          "Copie y pegue los nombres de sus alumnos en el cuadro de texto 'Nombre'.",
        copyPasteLast:
          "Copie y pegue los apellidos de sus alumnos en el cuadro de texto 'Apellido'.",
        confirm:
          "¡Estupendo! Ahora, verifiquemos que todo esté correcto. Puede volver si desea realizar cambios. Por favor verifique: ambos nombres de cada estudiante coinciden correctamente.",
        thoseStudentsAdded:
          "Estos estudiantes se han agregado a su cuenta.Por razones de seguridad, no podrá descargar las contraseñas nuevamente, asegúrese de guardar el archivo provisto en una ubicación segura en su computadora.Si el archivo no se descargó automáticamente, haga clic en el botón 'descargar lista de estudiantes' ahora.",
        note: "Nota: hay un límite de 100 estudiantes por importación."
      },

      messages: {
        create: "¡Se ha creado un alumno con éxito!",
        update: "¡Un estudiante ha sido actualizado!"
      },

      errors: {
        emptyList: "Aún no tienes alumnos.",
        details: "No se pudieron recuperar los datos de los estudiantes.",
        import:
          "¡UH oh! Algo salió mal. ¿Puedes intentar copiar y pegar los nombres de nuevo?",
        importPaste: "¡UH oh! No ha pegado nada en la columna."
      }
    }
  },

  stepsLabels: {
    step4: "Paso 4 - Confirmar"
  },

  common: {
    next: "Próximo",
    ok: "OK",
    unassigned: "No asignado",
    close: "Cerca",
    nextConfirm: "Siguiente paso - confirmar",
    continue: "Continuar",
    returnHome: "Regresar a la página principal",
    finish: "Terminar",
    confirm: "Confirmar",
    save: "Ahorrar",
    siteUsage: "Uso del sitio",
    reset: "Reiniciar"
  },

  errors: {
    basic: "No se pudieron cargar los datos.",
    unexpected: "Ha ocurrido un error inesperado.",
    admin:
      "¡UPS! No está autorizado para hacer esto. Comuníquese con el administrador de la cuenta."
  },

  tables: {
    lessons: {
      level: "Nivel",
      topic: "Tema",
      lesson: "Lección",
      summary: "Resumen",
      content: "Contenido",
      status: "Estado",
      testCategory: "Categoría de prueba"
    },

    reports: {
      firstName: "Nombre propio",
      lastName: "Apellido",
      username: "Nombre de usuario",
      topic: "Tema",
      lesson: "Lección",
      scoreForActivity: "Puntuación: {activityId}",
      correct: "Correcto",
      progress: "Progreso",
      levelNumber: "Nivel",
      lessonName: "Nombre de la lección",
      activity1: "Actividad 1",
      activity2: "Actividad 2",
      activity3: "Actividad 3",
      activity4: "Actividad 4"
    },

    classes: {
      group: "Grupo",
      subgroup: "Subgrupo",
      teacher: "Profesor",
      numberOfStudents: "Numero de estudiantes",
      lesson: "Lección actual",

      errors: {
        failedDelete:
          "No se pudo borrar el (los) grupo (s). Vuelve a intentarlo más tarde.",
        canBeAssign:
          "Los estudiantes solo pueden ser asignados a un grupo a la vez. Todos los estudiantes asignados a este grupo serán eliminados de su grupo actual."
      }
    }
  },

  components: {
    noActivitiesInLesson: "No hay actividades disponibles en esta lección.",
    selectAll: "Seleccionar todo",
    groupName: "Nombre del grupo",
    assignStudents: "Siguiente paso: asignar estudiantes",
    assignTeachers: "Siguiente paso - asignar maestros",
    noData: "Datos no disponibles.",
    videoSupport: "Lo sentimos, su navegador no admite videos incrustados.",
    generateUsername: "Generar nuevo nombre de usuario",
    password: "Contraseña",
    admin: "Administrador",
    view: "Vista",
    goBack: "Regresa",
    openLanguageMenu: "Abrir menú de idioma",
    isAdmin: "Es administrador",
    selectALevel: "Seleccionar un nivel",

    warnings: {
      deleteClasses: "Estás a punto de eliminar clases {clasessNames}"
    },

    errors: {
      selectGroups: "Primero seleccione los grupos.",
      editOneGroupAtOnce: "Puede editar solo 1 grupo a la vez",

      selectStudents: "Primero seleccione a los estudiantes.",
      deleteStudents: "Está a punto de eliminar estudiantes ",
      editOneStudentAtOnce: "Puede editar solo 1 alumno a la vez",
      failedToDeleteStudents:
        "No se pudieron borrar los estudiantes. Vuelve a intentarlo más tarde.",
      selectTeachers: "Seleccione los maestros primero.",
      deleteTeachers: "Estas a punto de eliminar maestros",
      editOneTeacherAtOnce: "Solo puedes editar 1 profesor a la vez.",
      failedToDeleteTeachers:
        "No se pudo borrar el (los) maestro (s). Vuelve a intentarlo más tarde.",
      teacherNames: "Por favor complete el nombre y apellido del maestro.",
      failedUsername:
        "Ha fallado la generación del nombre de usuario. Vuelve a intentarlo más tarde.",
      teacherEdit: "No se puede editar el nombre de usuario del profesor"
    }
  },

  navigation: {
    open: "Menú abierto",
    goToDashboard: "Ir al panel del profesor",
    teachers: "Profesores",
    students: "Estudiantes",
    lessons: "Lecciones",
    groups: "Grupos",
    reports: "Generador de informes",
    grammar: "Gramática para llevar",
    knowledge: "Base de conocimientos",
    logout: "Cerrar sesión",
    subgroups: "Asignar subgrupos"
  }
};
